function StepIndicator({ step, totalSteps, label }) {
  return (
    <div>
      <p className="text-sm font-medium text-gray-500">
        Paso {step} de {totalSteps}
        {label ? ` — ${label}` : ''}
      </p>
      <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-gray-100">
        <div
          className="h-full rounded-full bg-green-600 transition-all duration-300"
          style={{ width: `${(step / totalSteps) * 100}%` }}
        />
      </div>
    </div>
  );
}

export default StepIndicator;
